var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
var GeoPin = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("g", null,
            React.createElement("path", { d: "m5.666665,7.791665c-0.98571,0 -1.78572,-0.84001 -1.78572,-1.87501c0,-1.035 0.80001,-1.87499 1.78572,-1.87499c0.98571,0 1.78572,0.83999 1.78572,1.87499c0,1.035 -0.80001,1.87501 -1.78572,1.87501m-5,-1.87501c0,3.9375 5,9.75001 5,9.75001c0,0 5,-5.81251 5,-9.75001c0,-2.89874 -2.2393,-5.24999 -5,-5.24999c-2.76072,0 -5,2.35123 -5,5.24999z" }))));
};
export default GeoPin;
